'use client'

import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { ErrorPageProps } from 'types/common';
import { erroStyles } from 'styles/erroStyles';

// Dynamic imports for Chakra components
const Button = dynamic(() => import('@chakra-ui/react').then(mod => mod.Button));
const Center = dynamic(() => import('@chakra-ui/react').then(mod => mod.Center));
const Flex = dynamic(() => import('@chakra-ui/react').then(mod => mod.Flex));
const Heading = dynamic(() => import('@chakra-ui/react').then(mod => mod.Heading));
const Text = dynamic(() => import('@chakra-ui/react').then(mod => mod.Text));

// Lazy load icon
const AlertCircle = dynamic(() => 
  import('lucide-react').then(mod => mod.AlertCircle)
);

export default function ErrorPage({
  title = 'Algo deu errado!',
  message = 'Ops... Página não encontrada ou ocorreu um erro inesperado.',
  buttonText = 'Voltar para o início',
  redirectTo = '/',
}: ErrorPageProps) {
  const router = useRouter();

  return (
    <Center {...erroStyles.container}>
      <Flex {...erroStyles.card}>
        <AlertCircle {...erroStyles.icon} />
        <Heading {...erroStyles.heading} size="lg">
          {title}
        </Heading>
        <Text {...erroStyles.text}>
          {message}
        </Text>
        <Button 
          {...erroStyles.button} 
          onClick={() => router.push(redirectTo)}
        >
          {buttonText}
        </Button>
      </Flex>
    </Center>
  );
}